import React, { useState, useEffect } from 'react';

import Header from '../components/Header';
import MethodologyOverview from '../components/MethodologyOverview';
import MethodologyStrategy from '../components/MethodologyStrategy';
import MethodologyPersuasion from '../components/MethodologyPersuasion';
import MethodologyCommunication from '../components/MethodologyCommunication';

// Section theme configuration for this page
const SECTION_THEMES = {
    'methodology-overview': { bg: 'charcoal', isDark: true },
    'methodology-strategy': { bg: 'bone', isDark: false },
    'methodology-persuasion': { bg: 'charcoal', isDark: true },
    'methodology-communication': { bg: 'bone', isDark: false }
};

const NachosProcessPage = () => {
    const [activeSection, setActiveSection] = useState('methodology-overview');

    useEffect(() => {
        const handleScroll = () => {
            const sections = document.querySelectorAll('section[id]');
            const headerHeight = 100; // Header height offset

            // Find which section is currently at the top of the viewport
            for (let i = sections.length - 1; i >= 0; i--) {
                const section = sections[i];
                const rect = section.getBoundingClientRect();

                // If the section top is above or at the header
                if (rect.top <= headerHeight) {
                    setActiveSection(section.id);
                    break;
                }
            }
        };

        // Initial check
        handleScroll();

        // Add scroll listener
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const sectionTheme = SECTION_THEMES[activeSection] || SECTION_THEMES['methodology-overview'];

    return (
        <>
            <Header isDark={sectionTheme.isDark} />
            <main>
                <MethodologyOverview />
                <MethodologyStrategy />
                <MethodologyPersuasion />
                <MethodologyCommunication />
            </main>
        </>
    );
};

export default NachosProcessPage;
